import { useState } from "react";

const GOOGLE_BOOKING_URL =
  "https://script.google.com/macros/s/AKfycbwSU9JUNN7K0HP-M79lSGseUr7U2xry50xkEBWNxf2uqchVD4-JnerbjbU-S_YqeRGirw/exec";

const WHATSAPP_NUMBER = "919790964195";

const pageInfo = {
  ground: {
    title: "Ground Booking",
    subtitle: "Book our cricket ground for practice, matches and events.",
  },

  academy: {
    title: "Academy Booking",
    subtitle: "Join Hunters Cricket Academy and enquire about coaching.",
  },

  tournament: {
    title: "Tournament Registration",
    subtitle: "Register your team or player for upcoming cricket tournaments.",
  },

  contact: {
    title: "Contact Enquiry",
    subtitle: "Send an enquiry to the Hunters team.",
  },
};

const fields = {
  ground: [
    { name: "name", label: "Name", type: "text", required: true },
    { name: "mobile", label: "Mobile Number", type: "tel", required: true },
    { name: "email", label: "Email", type: "email", required: true },
    {
      name: "bookingDate",
      label: "Booking Date",
      type: "date",
      required: true,
    },
  
      {
    name: "slot",
    label: "Booking Slot",
    type: "select",
    required: true,
  }, 
    {
      name: "numberOfPlayers",
      label: "Number of Players",
      type: "number",
      required: true,
    },
  ],

  academy: [
    {
      name: "studentName",
      label: "Student Name",
      type: "text",
      required: true,
    },
    {
      name: "parentName",
      label: "Parent Name",
      type: "text",
      required: true,
    },
    {
      name: "mobile",
      label: "Mobile Number",
      type: "tel",
      required: true,
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      required: true,
    },
    {
      name: "age",
      label: "Age",
      type: "number",
      required: true,
    },
    {
      name: "batch",
      label: "Preferred Batch",
      type: "text",
      required: true,
    },
    {
      name: "experience",
      label: "Cricket Experience",
      type: "text",
      required: false,
    },
  ],

  tournament: [
    {
      name: "teamName",
      label: "Team Name",
      type: "text",
      required: true,
    },
    {
      name: "contactPerson",
      label: "Contact Person",
      type: "text",
      required: true,
    },
    {
      name: "mobile",
      label: "Mobile Number",
      type: "tel",
      required: true,
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      required: true,
    },
    {
      name: "tournamentName",
      label: "Tournament Name",
      type: "text",
      required: true,
    },
    {
      name: "numberOfPlayers",
      label: "Number of Players",
      type: "number",
      required: true,
    },
  ],

  contact: [
    {
      name: "name",
      label: "Name",
      type: "text",
      required: true,
    },
    {
      name: "mobile",
      label: "Mobile Number",
      type: "tel",
      required: true,
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      required: true,
    },
    {
      name: "subject",
      label: "Subject",
      type: "text",
      required: true,
    },
  ],
};

const emptyForm = {
  name: "",
  mobile: "",
  email: "",
  bookingDate: "",
  slot:"",
  numberOfPlayers: "",
  groundType: "Cricket Ground",
  notes: "",

  studentName: "",
  parentName: "",
  age: "",
  batch: "",
  experience: "",

  teamName: "",
  contactPerson: "",
  tournamentName: "",
  category: "",

  address: "",
  subject: "",
  message: "",
};

export default function BookingPage({ type }) {
  const info = pageInfo[type];

  const [formData, setFormData] = useState(emptyForm);
  const [submitting, setSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitting(true);
    setSubmitMessage("");

    try {
      // =========================
      // SEND TO GOOGLE SHEET
      // =========================

      const dataToSend = {
        ...formData,
        formType: type,
      };

      const response = await fetch(GOOGLE_BOOKING_URL, {
        method: "POST",
        body: JSON.stringify(dataToSend),
        headers: {
          "Content-Type": "text/plain;charset=utf-8",
        },
      });

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.error || "Unable to submit");
      }

      // =========================
      // WHATSAPP MESSAGE
      // =========================

      let whatsappMessage = "";

      // =========================
      // GROUND BOOKING
      // =========================

      if (type === "ground") {
        whatsappMessage = `
🏏 *NEW GROUND BOOKING*

Name: ${formData.name}
Mobile: ${formData.mobile}
Email: ${formData.email}

Booking Date: ${formData.bookingDate}
Booking Slot: ${formData.slot}

Number of Players: ${formData.numberOfPlayers}
Ground Type: ${formData.groundType}

Notes: ${formData.notes || "N/A"}

🏏 Hunters Cricket Academy
        `;
      }

      // =========================
      // ACADEMY BOOKING
      // =========================

      else if (type === "academy") {
        whatsappMessage = `
🏏 *NEW ACADEMY ENQUIRY*

Student Name: ${formData.studentName}
Parent Name: ${formData.parentName}

Age: ${formData.age}
Mobile: ${formData.mobile}
Email: ${formData.email}

Batch: ${formData.batch}
Cricket Experience: ${formData.experience || "N/A"}

🏏 Hunters Cricket Academy
        `;
      }

      // =========================
      // TOURNAMENT REGISTRATION
      // =========================

      else if (type === "tournament") {
        whatsappMessage = `
🏆 *NEW TOURNAMENT REGISTRATION*

Team Name: ${formData.teamName}
Contact Person: ${formData.contactPerson}

Mobile: ${formData.mobile}
Email: ${formData.email}

Tournament: ${formData.tournamentName}
Number of Players: ${formData.numberOfPlayers}
Category: ${formData.category || "N/A"}

🏏 Hunters Cricket Academy
        `;
      }

      // =========================
      // CONTACT ENQUIRY
      // =========================

      else if (type === "contact") {
        whatsappMessage = `
📩 *NEW CONTACT ENQUIRY*

Name: ${formData.name}
Mobile: ${formData.mobile}
Email: ${formData.email}

Subject: ${formData.subject || "N/A"}

Message:
${formData.message || "N/A"}

🏏 Hunters Cricket Academy
        `;
      }

      // =========================
      // OPEN WHATSAPP
      // =========================

      const whatsappURL =
        `https://wa.me/${WHATSAPP_NUMBER}?text=` +
        encodeURIComponent(whatsappMessage);

      window.open(whatsappURL, "_blank");

      // =========================
      // SUCCESS MESSAGE
      // =========================

      setSubmitMessage("✅ Submitted successfully!");

      // =========================
      // CLEAR FORM
      // =========================

      setFormData({
        ...emptyForm,
      });

    } catch (error) {
      console.error("Submission error:", error);

      setSubmitMessage(
        "❌ Unable to submit. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  if (!info) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <h1 className="text-2xl font-bold text-red-600">
          Invalid booking type
        </h1>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-white px-5 pt-32 pb-20">

      <div className="max-w-3xl mx-auto">

        {/* HEADER */}

        <div className="text-center text-white mb-10">

          <p className="uppercase tracking-[0.3em] text-white/60 font-semibold">
            Hunters Cricket Academy
          </p>

          <h1 className="text-4xl md:text-5xl font-extrabold mt-3">
            {info.title}
          </h1>

          <p className="mt-4 text-white/80">
            {info.subtitle}
          </p>

        </div>

        {/* FORM CARD */}

        <div className="bg-white rounded-3xl shadow-2xl p-6 md:p-10">

          <form onSubmit={handleSubmit}>

            <div className="grid md:grid-cols-2 gap-5">

              {fields[type]?.map((field) => (
  <div key={field.name}>

    <label className="block text-sm font-bold text-slate-800 mb-2">
      {field.label}
    </label>

    {field.type === "select" ? (
      <select
        name={field.name}
        value={formData[field.name]}
        onChange={handleChange}
        required={field.required}
        className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-600"
      >
        <option value="">
          Select Booking Slot
        </option>

        <option value="Morning">
          🌅 Morning
        </option>

        <option value="Noon">
          ☀️ Noon
        </option>

        <option value="Evening">
          🌆 Evening
        </option>
      </select>
    ) : (
      <input
        type={field.type}
        name={field.name}
        value={formData[field.name]}
        onChange={handleChange}
        required={field.required}
        className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
        placeholder={`Enter ${field.label}`}
      />
    )}

  </div>
))}

              {/* GROUND TYPE */}

              {type === "ground" && (
                <div>

                  <label className="block text-sm font-bold text-slate-800 mb-2">
                    Ground Type
                  </label>

                  <select
                    name="groundType"
                    value={formData.groundType}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-600"
                  >
                    <option value="Cricket Ground">
                      Cricket Ground
                    </option>

                    <option value="Practice Nets">
                      Practice Nets
                    </option>

                    <option value="Ground + Nets">
                      Ground + Nets
                    </option>
                  </select>

                </div>
              )}

            </div>

            {/* NOTES */}

            {(type === "ground" || type === "tournament") && (
              <div className="mt-5">

                <label className="block text-sm font-bold text-slate-800 mb-2">
                  Notes
                </label>

                <textarea
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  rows="4"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-600 resize-none"
                  placeholder="Enter any additional information"
                />

              </div>
            )}

            {/* ADDRESS */}

            {(type === "tournament" || type === "contact") && (
              <div className="mt-5">

                <label className="block text-sm font-bold text-slate-800 mb-2">
                  Address
                </label>

                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  rows="3"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-600 resize-none"
                  placeholder="Enter address"
                />

              </div>
            )}

            {/* CATEGORY */}

            {type === "tournament" && (
              <div className="mt-5">

                <label className="block text-sm font-bold text-slate-800 mb-2">
                  Category
                </label>

                <select
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-600"
                >

                  <option value="">
                    Select Category
                  </option>

                  <option value="Open">
                    Open
                  </option>

                  <option value="Under 19">
                    Under 19
                  </option>

                  <option value="Under 16">
                    Under 16
                  </option>

                  <option value="Under 14">
                    Under 14
                  </option>

                </select>

              </div>
            )}

            {/* CONTACT MESSAGE */}

            {type === "contact" && (
              <div className="mt-5">

                <label className="block text-sm font-bold text-slate-800 mb-2">
                  Message
                </label>

                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="6"
                  required
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-600 resize-none"
                  placeholder="Enter your message"
                />

              </div>
            )}

            {/* SUBMIT MESSAGE */}

            {submitMessage && (
              <div
                className={`mt-6 text-center font-bold ${
                  submitMessage.startsWith("✅")
                    ? "text-green-600"
                    : "text-red-600"
                }`}
              >
                {submitMessage}
              </div>
            )}

            {/* SUBMIT BUTTON */}

            <button
              type="submit"
              disabled={submitting}
              className="w-full mt-7 bg-slate-950 text-white font-bold py-4 rounded-xl hover:bg-blue-900 transition disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {submitting
                ? "Submitting..."
                : type === "ground"
                ? "Book Ground"
                : type === "academy"
                ? "Submit Academy Enquiry"
                : type === "tournament"
                ? "Register Tournament"
                : "Send Enquiry"}
            </button>

          </form>

        </div>

      </div>

    </div>
  );
}